import moment from 'moment'

/**
 * @example certificateValidity('2022-10-10T23:59:59Z') // -63 (As of today: 2022-12-13T13:43:00Z)
 */
export const certificateValidity = (date: string | null | undefined): number | null => {
  if (!date) {
    return null
  }

  const nowMoment = moment()
  return moment(date).diff(nowMoment, 'days')
}
